import { createFileRoute } from "@tanstack/react-router";
import Solutions from "@/pages/Solutions";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/th/solutions")({
  head: () => pageHead("/solutions", "th"),
  component: Solutions,
});
